// Values that arrive one at a time (a 100-file project answers its station and
// occupancy requests file by file) handed over together: the first arrival
// starts a timer, and everything that came in by then goes to `flush` at once.
export function batchArrivals<T>(ms: number, flush: (items: T[]) => void) {
  let items: T[] = [];
  let timer: ReturnType<typeof setTimeout> | null = null;
  return {
    add(item: T) {
      items.push(item);
      if (timer !== null) return;
      timer = setTimeout(() => {
        timer = null;
        const out = items;
        items = [];
        flush(out);
      }, ms);
    },
    cancel() {
      if (timer !== null) clearTimeout(timer);
      timer = null;
      items = [];
    },
  };
}
